import React from "react";
import { avatarTintFor } from "../avatarTints";

interface AccountNameProps {
  name: string;
}

/**
 * An account, as the first cell of any table that lists them: the initial in
 * its tinted disc, then the name.
 *
 * Shared rather than repeated because it turns up in four tables now — the
 * roster, the expired tab and the dashboard's two feeds — and the disc is the
 * thing the eye runs down to find a row again. Four copies of it is four
 * chances for one of them to end up a different size.
 */
export const AccountName: React.FC<AccountNameProps> = ({ name }) => (
  <div className="flex items-center gap-3">
    <span
      className={`w-8 h-8 3xl:w-9 3xl:h-9 rounded-full flex items-center justify-center flex-shrink-0 ${avatarTintFor(
        name
      )}`}
    >
      <span className="text-[13px] font-medium">{name.charAt(0)}</span>
    </span>
    <span className="text-[14px] text-ink font-medium truncate">{name}</span>
  </div>
);

export default AccountName;
